import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription, timer } from 'rxjs';
import { RestService } from '../../rest/rest.service';
import { AuthStore } from '../store/auth/auth.store';
import { UserActivityListenerService } from './user.activity.listener.service';

@Injectable({
  providedIn: 'root'
})
export class SessionExpirationPollingService {

  private readonly TIME_UNTIL_NEXT_POLLING = 1000 * 60; // 1 minute
  private restService = inject(RestService);
  private userActivityListenerService = inject(UserActivityListenerService);
  private authStore = inject(AuthStore);

  init(destroyRef: DestroyRef): void {
    let sub: Subscription = null;
    this.userActivityListenerService.userActivitySubject.asObservable()
      .pipe(takeUntilDestroyed(destroyRef))
      .subscribe(event => {
        if (event === 'routerChange') {
          this.checkIfExpired(destroyRef);
        } else {
          if (!sub) {
            sub = timer(this.TIME_UNTIL_NEXT_POLLING)
              .pipe(takeUntilDestroyed(destroyRef))
              .subscribe(v => {
                this.checkIfExpired(destroyRef);
                sub = null;
              });
          }
        }
      });
  }

  private checkIfExpired(destroyRef: DestroyRef): void {
    if (this.authStore.getCurrentUser()) {
      this.restService.isLoggedIn()
        .pipe(takeUntilDestroyed(destroyRef))
        .subscribe();
    }
  }
}
